import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import { Form, Input } from 'formik-semantic-ui';
import { PhoneInput } from '../custom/PhoneInput';

class UserInvite extends Component {
  render() {
    return (
      <Form.Children>
        <Input
          inputProps={{ placeholder: 'First Name' }}
          label="First Name"
          name="firstNameAdmin"
        />
        <Input
          inputProps={{ placeholder: 'Last Name' }}
          label="Last Name"
          name="lastNameAdmin"
        />
        <Form.Group>
          <Input
            width={6}
            inputProps={{
              icon: 'mail',
              iconPosition: 'left',
              placeholder: 'Email '
            }}
            label="Email"
            name="emailAdmin"
          />
          <PhoneInput
            width={6}
            name="phoneAdmin"
            label="Telephone no."
            setFieldValue={this.props.setFieldValue}
          />
        </Form.Group>
        <Button basic type="submit" color="olive" content="Teal">
          Send Invite
        </Button>
      </Form.Children>
    );
  }
}

export { UserInvite };
